export const NotFound = () => {
    const handleClick = () => {
        window.location.href = "/";
    }
    return (
        <div className="not-found">
            <span className="span-nf">Страница не найдена</span>
            <button className="btn-nf" onClick={handleClick}>Вернуться на главную</button>
        </div>
    )
}